import React, { Component } from 'react';
import './CustomCalendar.less';
import { Calendar } from 'primereact/calendar';

class CustomCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {}

  formatDisplayDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}/${month}/${day}`;
  };

  render() {
    const { props } = this;
    const { label, hideLabel, className, value, ...calendarProps } = props;
    
    return (
      <div className={`custom-calendar ${className ?? ''}`}>
        {!hideLabel && <div className="calendar-label">{`${label ?? '日付'}`}</div>}
        <div className="calendar-button-container">
          <Calendar
            {...calendarProps}
            value={value}
            className="custom-calendar-input"
            dateFormat="yy年mm月dd日"
            readOnlyInput
            showIcon
            selectionMode="single"
            clearButtonClassName="hidden"
          />
          <div className="calendar-button-display">
            <span className="date-text">
              {this.formatDisplayDate(value) || 'YYYY/MM/DD'}
            </span>
            {/* <svg 
              className="dropdown-arrow" 
              width="14" 
              height="14" 
              viewBox="0 0 14 14" 
              fill="none"
            >
              <path 
                d="M0 0L5 5L10 0" 
                stroke="currentColor" 
                strokeWidth="1.5"
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg> */}
            <svg 
              width="14" 
              height="14" 
              viewBox="0 0 14 14" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg" 
              className="p-icon p-dropdown-trigger-icon p-clickable" 
              aria-hidden="true" 
              data-pr-overlay-visible="false" 
              data-pc-section="dropdownicon"
            >
              <path d="M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z" fill="white"></path>
            </svg>
          </div>
        </div>
      </div>
    );
  }
}

CustomCalendar.propTypes = {};

export default CustomCalendar;
